/**
 * Utilidades HTTP sin dependencias del resto de la app.
 *
 * Viven aparte de `api.ts` y `session.ts` para que no haya ciclos de importación
 * entre el cliente, la sesión y las utilidades.
 */

/** URL completa de un endpoint. Vacío = mismo origen. */
export function apiUrl(path: string): string {
  const base = import.meta.env.VITE_API_URL ?? "";
  return `${base}${path}`;
}

/**
 * Identificador único de petición. Se manda en `X-Request-ID` y es lo que
 * permite encontrar en los logs la venta que "no se cobró".
 */
export function newRequestId(): string {
  if (typeof crypto !== "undefined" && "randomUUID" in crypto) {
    return crypto.randomUUID();
  }
  return `web-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/**
 * Clave de idempotencia para una operación que mueve dinero.
 *
 * Se genera **en el cliente y una sola vez por venta**: si se generara en cada
 * reintento, cada intento sería una venta distinta y el problema que resuelve
 * la idempotencia seguiría ahí.
 */
export function newIdempotencyKey(prefix = "pos"): string {
  return `${prefix}-${newRequestId()}`;
}
